import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";

import { FilterConfigView } from "../filter-config.view";
@Component({
    selector: "timezone-setting-section",
    templateUrl: "./timezone-setting.view.html",
    providers: []
})
export class TimezoneSettingView extends FilterConfigView {}
